import { useReducer } from 'react';

const reducer = () => ({});

export function useForceUpdate(): () => void {
  const [, dispatch] = useReducer(reducer, {});
  return dispatch;
}
